"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("../../utils.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var gradientColourStyle = {
  overflow: "auto",
  height: "15px",
  margin: "2px 6px 2px 6px",
  verticalAlign: "middle",
  width: "200px",
  display: "inline-block"
};
var gradientLevelStyle = {
  whiteSpace: "nowrap",
  fontSize: "10px",
  verticalAlign: "middle",
  display: "table-cell"
};
var gradientLevelMinStyle = {
  textAlign: "right"
};
var gradientLevelMaxStyle = {
  textAlign: "left"
};

var renderGradient = function renderGradient(_ref, index) {
  var fromValue = _ref.fromValue,
      toValue = _ref.toValue,
      colours = _ref.colours;
  var spanStyle = {
    backgroundImage: "linear-gradient(to right, ".concat(colours.join(", "), ")")
  };
  return fromValue < toValue ? /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: "table-row"
    },
    key: "gradient_".concat(index)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: _objectSpread(_objectSpread({}, gradientLevelStyle), gradientLevelMinStyle)
  }, (0, _utils.numberWithCommas)(fromValue)), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: "table-cell",
      verticalAlign: "middle"
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    style: _objectSpread(_objectSpread({}, gradientColourStyle), spanStyle)
  })), /*#__PURE__*/_react["default"].createElement("div", {
    style: _objectSpread(_objectSpread({}, gradientLevelStyle), gradientLevelMaxStyle)
  }, (0, _utils.numberWithCommas)(toValue))) : null;
};

var gradientLegendStyle = {
  fontSize: "12px",
  padding: "12px 0",
  marginLeft: "10px",
  textAlign: "center",
  display: "inline-block"
};

var GradientHeatmapLegend = function GradientHeatmapLegend(_ref2) {
  var gradients = _ref2.gradients,
      unit = _ref2.unit;
  return gradients.some(function (gradient) {
    return gradient.fromValue !== 0 || gradient.toValue !== 0;
  }) && /*#__PURE__*/_react["default"].createElement("div", {
    style: gradientLegendStyle
  }, /*#__PURE__*/_react["default"].createElement("div", null, !unit ? /*#__PURE__*/_react["default"].createElement("span", null, "Expression level") : unit.includes("fold change") ? /*#__PURE__*/_react["default"].createElement("span", null, "Log", /*#__PURE__*/_react["default"].createElement("sub", null, "2"), "-fold change") : /*#__PURE__*/_react["default"].createElement("span", null, "Expression level in ", unit)), gradients.map(renderGradient));
};

GradientHeatmapLegend.propTypes = {
  gradients: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    fromValue: _propTypes["default"].number,
    toValue: _propTypes["default"].number,
    colours: _propTypes["default"].arrayOf(_propTypes["default"].string)
  })).isRequired,
  unit: _propTypes["default"].string.isRequired
};
var _default = GradientHeatmapLegend;
exports["default"] = _default;